const errorsDJ = {
  data() {
    return {
      errorsDj: []
    }
  },
  methods: {
    hasError(field) {
      return Boolean(this.errorsDj[field])
    },
    hasErrorNested(field, nested, index) {
      if (nested) {
        if (nested[index]) {
          return Boolean(nested[index][field])
        }
      }
      return false
    },
    getError(field) {
      return this.errorsDj[field]
    },
    getErrorNested(nested, index, field) {
      return nested[index][field]
    },
    cleanErrors() {
      this.errorsDJ = []
    }
  }
}
export default errorsDJ
